import React from 'react';
import { BulkOperation } from '../components';

export default () => {
    return (
        <BulkOperation.Home />
    )
}